import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=13bfdf82"
import script from "./PlanItem.vue?vue&type=script&lang=ts"
export * from "./PlanItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports